import { add, isBefore, isWithinInterval, sub } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { TFunction } from 'i18next'
import UpcomingWebinarType from 'pages/Home/UpcomingWebinarType'

export const I18NEXT_PREFIX = 'home.upcomingWebinarsSection.upcomingWebinar'
export const UPCOMING_WEBINAR_DURATION_MIN = 60

function buildStartTimeWithBuffer(): Date {
  return sub(new Date(), { hours: 1 })
}

export function isInNonAdminDateRange(upcomingWebinar: UpcomingWebinarType): boolean {
  return isWithinInterval(new Date(upcomingWebinar.date), { start: buildStartTimeWithBuffer(), end: add(new Date(), { months: 2 }) })
}

export function isInPast(upcomingWebinar: UpcomingWebinarType): boolean {
  return isBefore(new Date(upcomingWebinar.date), buildStartTimeWithBuffer())
}

export function formatDay(timezone: string, dateUtc: string, t: TFunction): string {
  return formatInTimeZone(dateUtc, timezone, t(`${I18NEXT_PREFIX}.dateFormat`))
}

export function formatTime(timezone: string, dateUtc: string, t: TFunction): string {
  const currentTimezoneCode = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]

  return t(`${I18NEXT_PREFIX}.time`, {
    startTime: formatInTimeZone(dateUtc, timezone, t(`${I18NEXT_PREFIX}.hourFormat`)),
    endTime: formatInTimeZone(add(new Date(dateUtc), { minutes: UPCOMING_WEBINAR_DURATION_MIN }), timezone, t(`${I18NEXT_PREFIX}.hourFormat`)),
    timezone: currentTimezoneCode
  })
}

export function formatForSearchIndex(timezone: string, dateUtc: string, t: TFunction): string {
  return formatInTimeZone(new Date(dateUtc), timezone, t(`${I18NEXT_PREFIX}.searchFormat`))
}
